import { render, staticRenderFns } from "./search-input.vue?vue&type=template&id=44d4042c&scoped=true"
import script from "./search-input.vue?vue&type=script&lang=js"
export * from "./search-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d4042c",
  null
  
)

export default component.exports